module.exports = __webpack_public_path__ + "static/media/logo_elite_pass.50472e00.png";